import React from 'react';
import {Provider} from "react-redux";
import configure from "../../store/configure";
import AnnounceListContainer from "./container/AnnounceListContainer";
import Layout from "../../component/layout/Layout";

const AnnounceListPage = () => {

    return (
        <Provider store={configure}>
            <Layout>
                <AnnounceListContainer />
            </Layout>
        </Provider>
    );
};

export default AnnounceListPage;
